import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from 'react';
import classnames from 'classnames';
import { trackEvent } from 'latitude-analytics';
import SvgInline from '@latitude/svg-inline';
import './_search-form.scss';

var SearchForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchForm, _React$Component);

  function SearchForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleKeyDown = function (event) {
      if (!_this.props.active) return;

      if (event.keyCode === 27) {
        _this.props.onRequestClose();
      }
    };

    _this.closeSearchInput = function () {
      _this.searchInputContainerRef.current.classList.remove('is-active');
    };

    _this.handleClick = function (ev) {
      if (!_this.props.active) return;
      var clickTarget = ev.target;
      var wrapperNode = _this.formRef && _this.formRef.current;

      if (wrapperNode && clickTarget instanceof Node && !wrapperNode.contains(clickTarget)) {
        _this.props.onRequestClose();
      }
    };

    _this.formRef = /*#__PURE__*/React.createRef();
    _this.searchInputContainerRef = /*#__PURE__*/React.createRef();
    _this.searchInputRef = /*#__PURE__*/React.createRef();
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = SearchForm.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.active && this.props.active !== prevProps.active) {
      this.searchInputRef.current.focus();
    }

    if (this.props.animateClose && this.props.animateClose !== prevProps.animateClose) {
      this.searchInputContainerRef.current.classList.remove('is-active');
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
    document.removeEventListener('mousedown', this.handleClick, false);
  }
  /*
   * Close the popup on Esc key,
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        active = _this$props.active,
        analytics = _this$props.analytics,
        onRequestClose = _this$props.onRequestClose,
        searchFormData = _this$props.searchFormData;
    var searchText = searchFormData && searchFormData.searchText;
    var searchAction = searchFormData && searchFormData.searchAction;
    return /*#__PURE__*/React.createElement("form", {
      ref: this.formRef,
      key: "abc",
      className: classnames('search', {
        'is-active': active
      }),
      method: "get",
      action: searchAction
    }, /*#__PURE__*/React.createElement("div", {
      className: "search__label"
    }, searchText || 'Search'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "search__close search__close--mobile",
      onClick: onRequestClose
    }, /*#__PURE__*/React.createElement(SvgInline, {
      className: "search__close-icon",
      name: "cross",
      ariaLabel: "Close search"
    })), /*#__PURE__*/React.createElement("div", {
      ref: this.searchInputContainerRef,
      className: classnames('search__input-container', {
        'is-active': active
      })
    }, /*#__PURE__*/React.createElement("input", {
      ref: this.searchInputRef,
      type: "text",
      autoFocus: true,
      className: "search__input",
      name: "q"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "search__submit",
      onClick: function onClick() {
        trackEvent(analytics, {
          category: 'search',
          action: 'interaction',
          label: 'search',
          location: 'header'
        });

        _this2.formRef.current.submit();
      }
    }, /*#__PURE__*/React.createElement(SvgInline, {
      className: "search__submit-icon",
      "aria-label": "Search",
      name: "search"
    }))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "search__close search__close--desktop",
      onClick: onRequestClose
    }, /*#__PURE__*/React.createElement(SvgInline, {
      className: "search__close-icon",
      name: "cross",
      ariaLabel: "Close search"
    })));
  };

  return SearchForm;
}(React.Component);

export default SearchForm;